// @flow
import React, { Component } from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Helper from '../../../helper/Helper';
import Modal from '../modal/Modal';
import { LocaleLink } from '../';
import I18n from '../../../i18n/I18n';
import noonLogo from '../../../images/logo/noon.svg';
import logoEn from '../../../images/logo/seller-lab-logo.svg';
import logoAr from '../../../images/logo/seller-lab-logo-arabic.svg';
import CONFIG from '../../../config';
import Button from '../button/Button';
import sideMenu from '../../../constants/sideMenu';
import Icon from '../Icon';
import styles from './styles.js';

class MainMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMobileMenu: false,
            modalOpen: false,
            itemCount: '',
            valueError: false,
            appContext: 'Co',
            currentApp: 'Co',
            appNav: [],
            smallMenu: true,
            hoverView: false,
        };
        this.toggleMobileMenu = this.toggleMobileMenu.bind();
        this.inputChange = this.inputChange.bind();
        this.submit = this.submit.bind();
    }
    componentDidMount() {
        window.addEventListener(
            !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
                ? 'touchstart'
                : 'click',
            this.handleClickOutside,
            true,
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
                ? 'touchstart'
                : 'click',
            this.handleClickOutside,
            true,
        );
    }

    openModal() {
        this.setState({
            modalOpen: true,
        });
    }

    onCloseModal() {
        this.setState({
            modalOpen: false,
            itemCount: '',
            numberError: '',
        });
    }
    toggleMobileMenu = () => {
        this.setState({
            showMobileMenu: !this.state.showMobileMenu,
        });
    };
    handleClickOutside = () => {
        this.setState({ showMobileMenu: false });
    };

    inputChange = e => {
        this.setState({
            valueError: false,
            itemCount: e.target.value.replace(/\D/g, ''),
        });
    };

    onKeyPress = e => {
        if (e.key !== 'Enter') {
            return;
        }

        this.submit();
    };

    submit = () => {
        if (this.state.itemCount) {
            if (
                Number(this.state.itemCount) < 1 ||
                Number(this.state.itemCount) > 9999
            ) {
                this.setState({
                    valueError: true,
                });
            } else {
                this.props.postOutbound(this.state.itemCount);
                this.setState({
                    modalOpen: false,
                    itemCount: '',
                });
            }
        }
    };

    changeApp = appId => {
        if (appId === this.state.currentApp) return;
        this.setState({ currentApp: appId });
    };

    navigateTo = (appId, appName, path) => {
        if (appId !== this.state.appContext && path !== '') {
            window.location.replace(
                `https://${appName.toLowerCase()}.${Helper.getUrlDomain()}/${Helper.getUrlLocale()}/${path.replace('/','',)}`,
            );
        }
    };

    toggleSmallMenu = () => {
        const newState = this.state;
        newState.smallMenu = !this.state.smallMenu;
        if (!this.state.smallMenu) {
            newState.hoverView = false;
        }
        // localStorage.setItem('smallMenu', !this.state.smallMenu);
        this.setState(newState);
    };

    toggleHoverView = val => {
        console.log(val);
        this.setState(prevState => ({
            hoverView: val,
            // smallMenu : val
        }));
    };
    redirectToHelp = helpPath => {
          helpPath = helpPath.replace('{$locale}', Helper.getUrlLocale());
          window.open(`${helpPath}`, '_blank');
      };

    render() {
        // const { isOfferCounting, offerCount, seller, isNoonUser, menuOptions } = this.props;
        const {
            t,
            menuItem,
            hideMenu,
            seller,
            isNoonUser,
            menuOptions,
        } = this.props;

        const { currentApp, appContext, smallMenu, hoverView } = this.state;

        const isActiveClass = '';

        const lang = Helper.getLang();
        let logo = lang === 'ar' ? logoAr : logoEn;

        let mainSidePanelClass = 'sidePanelWrapper';
        if (hideMenu) {
            mainSidePanelClass = 'sidePanelMobileMenu';
        }

        const mainPath = '/';

        let appNav = [];
        if (this.props.menuOptions) {
            appNav = this.props.menuOptions.filter((obj, pos, arr) => {
                return (
                    arr
                        .map(mapObj => mapObj['app_code'])
                        .indexOf(obj['app_code']) === pos
                );
            });
        }

        let pat = /^https|http?:\/\//i;

        return (
            <div className="container layout1">
                <div className={`${hideMenu ? 'mobileMenu' : 'mobileWrapper'}`}>
                    <div className="hamburgerWrapper">
                        <a
                            className="hamburger"
                            onClick={this.toggleMobileMenu}
                        >
                            <div
                                className={`hamburgerBox hamburgerSqueeze ${isActiveClass}`}
                            >
                                <div className="hamburgerInner" />
                            </div>
                        </a>
                    </div>
                </div>
                <div
                    className={`${mainSidePanelClass} ${
                        this.state.showMobileMenu ? ' mobileSidePanel' : ''
                    } ${smallMenu && !hoverView ? 'smallSidePanel' : ''}`}
                >
                    <nav
                        className={`pcodedNavbar menuposFixed ${
                            smallMenu && !hoverView ? 'navbarCollapsed' : ''
                        }`}
                    >
                        <div
                            className="navbarWrapper"
                            onMouseEnter={
                                smallMenu
                                    ? () => this.toggleHoverView(1)
                                    : () => {}
                            }
                            onMouseLeave={
                                smallMenu
                                    ? () => this.toggleHoverView(0)
                                    : () => {}
                            }
                        >
                            <div className="navbarBrand headerLogo">
                                <a className="bBrand">
                                    <div className="bBg">
                                        <img
                                            src={noonLogo}
                                            className={`logo  ${
                                                smallMenu && !hoverView
                                                    ? 'smallLogo'
                                                    : ''
                                            }`}
                                        />
                                    </div>
                                    <span className="bTitle">
                                        <span className="mainTitle">
                                            {I18n.getText('menu.seller-lab')}
                                        </span>
                                        <span className="subTitle">
                                            {I18n.getText('menu.core')}
                                        </span>
                                    </span>
                                </a>
                                <a
                                    className="mobileMenu on"
                                    id="mobile-collapse"
                                >
                                    <span />
                                </a>
                            </div>
                            <div className="navbarContent scrollDiv ps ps--active-y">
                                <div className="layout1Nav">
                                    <ul
                                        className="sidemenu nav flexColumn"
                                        role="tablist"
                                    >
                                        {appNav.map((app, index) => (
                                            <li
                                                className={`${
                                                    currentApp === app.app_code
                                                        ? 'active'
                                                        : ''
                                                } app${app}`}
                                                onClick={() =>
                                                    this.changeApp(app.app_code)
                                                }
                                                key={`appMenu${index}`}
                                            >
                                                <a
                                                    className="navLink textLeft"
                                                    data-cont="navigation"
                                                >
                                                    {app.app_code}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>

                                    {appNav.map((app, index) => (
                                        <div
                                            className={`sideContent`}
                                            style={{
                                                display:
                                                    currentApp === app.app_code
                                                        ? 'block'
                                                        : 'none',
                                            }}
                                            key={`appCtr${index}`}
                                        >
                                            <div className="sidelink ">
                                                <ul className="nav pcodedInnerNavbar">
                                                    <li
                                                        className="navItem pcodedMenuCaption"
                                                        key={`appTitle${index}`}
                                                    >
                                                        <label>
                                                            {app.app_name}
                                                        </label>
                                                    </li>
                                                    {menuOptions.map(
                                                        (item, index) => {
                                                            if (
                                                                item.app_code ==
                                                                    app.app_code &&
                                                                item.is_active ==
                                                                    1 &&
                                                                item.app_code ==
                                                                    appContext
                                                            ) {
                                                                return (
                                                                    <li
                                                                        className={`navItem ${
                                                                            mainPath &&
                                                                            `/${
                                                                                mainPath[2]
                                                                            }` ===
                                                                                item.path
                                                                                ? ' active'
                                                                                : ''
                                                                        }`}
                                                                        key={`sideMenu${index}`}
                                                                    >
                                                                        <LocaleLink
                                                                            href={{
                                                                                pathname:
                                                                                    item.path,
                                                                            }}
                                                                            to={
                                                                                item.path
                                                                            }
                                                                            prefetch
                                                                        >
                                                                            <a
                                                                                className={`navLink menuList`}
                                                                            >
                                                                                <span className="pcoded-micon" />
                                                                                <span className="pcoded-mtext">
                                                                                    {
                                                                                        item.name
                                                                                    }
                                                                                </span>
                                                                            </a>
                                                                        </LocaleLink>
                                                                    </li>
                                                                );
                                                            } else if (
                                                                item.app_code ==
                                                                    app.app_code &&
                                                                item.is_active ==
                                                                    1 &&
                                                                item.app_code !=
                                                                    appContext
                                                            ) {
                                                                return item && item.path && pat.test(item.path) ? (
                                                                    <a
                                                                        className={`navLink menuList`}
                                                                        onClick={() =>
                                                                            this.redirectToHelp(item.path)
                                                                        }
                                                                    >
                                                                        <span className="pcoded-micon" />
                                                                        <span className="pcoded-mtext">
                                                                            {
                                                                                item.name
                                                                            }
                                                                        </span>
                                                                    </a>
                                                                ) : (
                                                                    <a
                                                                        className={`navLink menuList`}
                                                                        onClick={() =>
                                                                            this.navigateTo(
                                                                                item.app_code,
                                                                                item.app_name,
                                                                                item.path,
                                                                            )
                                                                        }
                                                                    >
                                                                        <span className="pcoded-micon" />
                                                                        <span className="pcoded-mtext">
                                                                            {
                                                                                item.name
                                                                            }
                                                                        </span>
                                                                    </a>
                                                                );
                                                            }
                                                        },
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
                <style jsx>{styles}</style>
            </div>
        );
        //     return (
        //       <div className={`${styles.container} ${styles.layout1}`}>

        //           <div className={`${hideMenu ? styles.showMobileMenu : styles.mobileWrapper}`}>
        //               <div className={styles.hamburgerWrapper}>
        //                   <a className="hamburger" onClick={this.toggleMobileMenu}>
        //                       <div className={`hamburgerBox hamburgerSqueeze ${isActiveClass}`}>
        //                           <div className="hamburgerInner" />
        //                       </div>
        //                   </a>
        //               </div>
        //               <div className="logoWrapper">
        //                   <LocaleLink to="/">

        //                           <img src={lang === 'ar' ? logoAr : logoEn} className="logo" alt="noonlogo" />

        //                   </LocaleLink>
        //               </div>
        //           </div>
        //           <div
        //               className={`${mainSidePanelClass} ${this.state.showMobileMenu ? ' mobileSidePanel' : ''} ${
        //                   smallMenu && !hoverView ? 'smallSidePanel' : ''
        //               }`}
        //           >
        //               <nav className={`${styles.pcodedNavbar} ${styles.menuposFixed} ${smallMenu && !hoverView ? styles.navbarCollapsed : ''}`}>
        //                   <div
        //                       className={`${styles.navbarWrapper}`}
        //                       onMouseEnter={smallMenu ? () => this.toggleHoverView(1) : () => {}}
        //                       onMouseLeave={smallMenu ? () => this.toggleHoverView(0) : () => {}}
        //                   >
        //                       <div className={`${styles.navbarBrand, styles.headerLogo}`}>
        //                           <a className={`${styles.bBrand}`}>
        //                               <div className={`${styles.bBg}`}>
        //                                   <img
        //                                       // src={noonLogo}
        //                                       className={`${styles.logo}  ${smallMenu && !hoverView ? styles.smallLogo : ''}`}
        //                                   />
        //                               </div>
        //                               <span className={`${styles.bTitle}`}>
        //                                   <span className={`${styles.mainTitle}`}>seller lab</span>
        //                                   <span className={`${styles.subTitle}`}>core</span>
        //                               </span>
        //                           </a>
        //                           <a className={`${styles.mobileMenu, styles.on}`} id="mobile-collapse">
        //                               <span />
        //                           </a>
        //                       </div>
        //                       <div className={`${styles.navbarContent, styles.scrollDiv, styles.ps}`}>
        //                           <div className={`${styles.layout1Nav}`}>
        //                               <ul className={`${styles.sidemenu, styles.nav, styles.flexColumn}`} role="tablist">
        //                                   {appNav.map((app, index) => (

        //                                       <li className={`${currentApp === app.app_code ? styles.active : ''} app${app.app_code}`} onClick={ () => this.changeApp(app.app_code)} key={`appMenu${index}`}>
        //                                           <a className={`${styles.navLink, styles.textLeft}`} data-cont="navigation">
        //                                               {app.app_code}
        //                                           </a>
        //                                       </li>

        //                                   ))}
        //                               </ul>

        //                               { appNav.map((app, index) => (
        //                                   <div className={`${styles.sideContent}` } style={{display: (currentApp === app.app_code ? 'block' : 'none')}}  key={`appCtr${index}`}>
        //                                       <div className={`${styles.sideLink}` }>
        //                                           <ul className={`${styles.nav, styles.pcodedInnerNavbar}` }>
        //                                               <li className={`${styles.navItem, styles.pcodedMenuCaption}` } key={`appTitle${index}`}>
        //                                                   <label>{app.app_name}</label>
        //                                               </li>
        //                                               {menuOptions.map((item, index) => {
        //                                                       if(item.app_code == app.app_code && item.is_active == 1 && item.app_code == appContext) {
        //                                                               return (
        //                                                               <li className={`${styles.navItem} ${mainPath && `/${mainPath[2]}` === item.path ?  styles.active : ''}`} key={`sideMenu${index}`}  >
        //                                                                   <LocaleLink href={{ pathname: item.path }} to={item.path} prefetch>
        //                                                                       <a className={`${styles.navLink, styles.menuList}`}>
        //                                                                           <span className={`${styles.pcodedMicon}`} />
        //                                                                           <span className={`${styles.pcodedMtext}`}>{item.name}</span>
        //                                                                       </a>
        //                                                                   </LocaleLink>
        //                                                               </li>
        //                                                               )
        //                                                       } else if(item.app_code == app.app_code && item.is_active == 1 && item.app_code != appContext) {
        //                                                               return (
        //                                                                   <a className={`${styles.navLink, styles.menuList}`} onClick={() => this.navigateTo(item.app_code, item.app_name, item.path)}>
        //                                                                           <span className={`${styles.pcodedMicon}`} />
        //                                                                           <span className={`${styles.pcodedMtext}`}>{item.name}</span>
        //                                                                   </a>
        //                                                               )
        //                                                       }

        //                                               })}
        //                                           </ul>
        //                                       </div>
        //                                   </div>
        //                               ))}
        //                           </div>
        //                       </div>
        //                   </div>
        //               </nav>
        //           </div>
        //           {/* <style jsx global>
        //               {globalStyles}
        //           </style> */}
        //           {/* <style jsx>{styles}</style> */}
        //       </div>
        //   );
    }
}

MainMenu.propTypes = {
    className: PropTypes.string,
};

MainMenu.getDefaultProps = {};

export default enhanceWithClickOutside(MainMenu);



// WEBPACK FOOTER //
// ./src/components/common/mainMenu/MainMenu.js